import React from 'react';
import './skills.css';
import Fronted from './Fronted';
import Backend from './Backend';

const Skills = () => (
  <section className="skills section" id="skills">
    <h2 className="section_title">Skills</h2>
    <span className="section_subtitle">My technical level</span>
    <div className="skills_container container grid">
      <Fronted />
      <Backend />
    </div>

  </section>
);

export default Skills;
